import { analytics } from 'Modules/Analytics'

const config = {
  domain: 'Academy',
  subdomain: 'Resources',
}

interface ResourceDownloaded {
  resourceName: string
  documentName: string
  userId: number
  resourceId: string
}

interface ResourceViewed {
  resourceId: string
  resourceName: string
  resourceType: string
  resourceTags: string[]
}

interface ResourceClicked {
  resourceId: string
  resourceName: string
  resourceType: string
  section: string
  position: number
}

interface NextPageClicked {
  pageNumber: number
}

interface PreviousPageClicked {
  pageNumber: number
}

interface PageClicked {
  pageNumber: number
}

interface RelatedCourseClicked {
  courseId: string
  courseTitle: string
}

interface RelatedResourceClicked {
  resourceId: string
  resourceName: string
  resourceType: string
}

interface CtaCourseClicked {
  courseId: string
  courseTitle: string
}

interface CtaResourceClicked {
  resourceId: string
  resourceName: string
  resourceType: string
}

interface CtaToolClicked {
  destinationUrl: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NavigationItemClicked {}

interface DismissedClicked {
  userId: number
  resourceId: string
  resourceName: string
  resourceType: string
}

interface TopicClicked {
  userId: number
  topicTitle: string
}

interface ExploreAcademyClicked {
  userId: number
  option: string
}
interface HeaderBackToHomeClicked {
  userId: number
}
interface CarouselClicked {
  sectionName: string
}
interface InProgressClicked {
  sectionName: string
}
interface SavedResourcesClicked {
  sectionName: string
}
interface HomePageSectionClicked {
  resourceId: string
  resourceType: string
  resourceName: string
}

interface ResourceBookmarked {
  resourceId: string
  resourceName: string
  resourceType: string
}

interface ViewAllClicked {
  sectionName: string
}

interface CourseSlideClick {
  resourceId: string
  courseTitle: string
  assetId: string | null
  templateId: string | null
}

interface CourseSlideViewed {
  resourceId: string
  courseTitle: string
  slideId: string
  slideNumber: number
}

interface CourseClicked {
  resourceId: string
  courseName: string
}

interface AllResourcesLoadTracked {
  loadTime: number
  isFirstLoad: boolean
}

interface SearchClicked {
  query: string
  topic: string[]
  status: string[]
  resourceType: string[]
  resourceLevel: string[]
  new: boolean
  updated: boolean
  downloaded: boolean
  // purchased: boolean  purchased is not currently an option, but we will want to track it once it is
}

interface SearchResultClicked {
  searchQuery: string
  searchTopic: string[]
  serachStatus: string[]
  searchResourceType: string[]
  searchResourceLevel: string[]
  searchNew: boolean
  searchUpdated: boolean
  searchDownloaded: boolean
  // searchPurchased: boolean purchased is not currently an option, but we will want to track it once it is
  sortingCategory: string
  resourceId: string
  resourceName: string
  resourceType: string
}

export const resources = {
  Resource_Downloaded: {
    Resource_Downloaded: (param: ResourceDownloaded) => param,
    config,
  },
  Resource_Viewed: {
    Resource_Viewed: (param: ResourceViewed) => param,
    config,
  },
  Resource_Clicked: {
    Resource_Clicked: (param: ResourceClicked) => param,
    config,
  },
  Next_Page_Clicked: {
    Next_Page_Clicked: (param: NextPageClicked) => param,
    config,
  },
  Previous_Page_Clicked: {
    Previous_Page_Clicked: (param: PreviousPageClicked) => param,
    config,
  },
  Page_Clicked: {
    Page_Clicked: (param: PageClicked) => param,
    config,
  },
  Plus_Resource_Clicked: {
    ResourceClicked: (param: ResourceClicked) => param,
    config,
  },
  Related_Course_Clicked: {
    Related_Course_Clicked: (param: RelatedCourseClicked) => param,
    config,
  },
  Related_Resource_Clicked: {
    Related_Resource_Clicked: (param: RelatedResourceClicked) => param,
    config,
  },
  CTA_Course_Clicked: {
    CTA_Course_Clicked: (param: CtaCourseClicked) => param,
    config,
  },
  CTA_Resource_Clicked: {
    CTA_Resource_Clicked: (param: CtaResourceClicked) => param,
    config,
  },
  CTA_Tool_Clicked: {
    CTA_Tool_Clicked: (param: CtaToolClicked) => param,
    config,
  },
  Clicked: {
    Clicked: (param: NavigationItemClicked) => param,
    config,
  },
  Dismissed_Clicked: {
    Dismissed_Clicked: (param: DismissedClicked) => param,
    config,
  },
  Topic_Clicked: {
    Explore_Academy_Clicked: (param: TopicClicked) => param,
    config,
  },
  Explore_Academy_Clicked: {
    Explore_Academy_Clicked: (param: ExploreAcademyClicked) => param,
    config,
  },
  Header_Back_To_Home_Clicked: {
    Header_Back_To_Home_Clicked: (param: HeaderBackToHomeClicked) => param,
    config,
  },
  Carousel_Clicked: {
    Carousel_Clicked: (param: CarouselClicked) => param,
    config,
  },
  In_Progress_Clicked: {
    In_Progress_Clicked: (param: InProgressClicked) => param,
    config,
  },
  Saved_Resources_Clicked: {
    Saved_Resources_Clicked: (param: SavedResourcesClicked) => param,
    config,
  },
  Intro_Clicked: {
    Intro_Clicked: (param: HomePageSectionClicked) => param,
    config,
  },
  Recommended_Clicked: {
    Recommended_Clicked: (param: HomePageSectionClicked) => param,
    config,
  },
  Featured_Clicked: {
    Featured_Clicked: (param: HomePageSectionClicked) => param,
    config,
  },
  Popular_Courses_Clicked: {
    Popular_Courses_Clicked: (param: HomePageSectionClicked) => param,
    config,
  },
  Popular_Templates_Clicked: {
    Popular_Templates_Clicked: (param: HomePageSectionClicked) => param,
    config,
  },
  Recently_Viewed_Clicked: {
    Recently_Viewed_Clicked: (param: HomePageSectionClicked) => param,
    config,
  },
  Resource_Bookmarked: {
    Resource_Bookmarked: (param: ResourceBookmarked) => param,
    config,
  },
  Resource_Unbookmarked: {
    Resource_Unbookmarked: (param: ResourceBookmarked) => param,
    config,
  },
  In_Progress_Section_Clicked: {
    In_Progress_Section_Clicked: () => {
      // No properties expected
    },
    config,
  },
  Saved_Resources_Section_Clicked: {
    Saved_Resources_Section_Clicked: () => {
      // No properties expected
    },
    config,
  },
  View_All_Clicked: {
    View_All_Clicked: (param: ViewAllClicked) => param,
    config,
  },
  Course_Next_Clicked: {
    Course_Next_Clicked: (param: CourseSlideClick) => param,
    config,
  },
  Course_Previous_Clicked: {
    Course_Previous_Clicked: (param: CourseSlideClick) => param,
    config,
  },
  Course_Started: {
    Course_Started: (param: CourseSlideClick) => param,
    config,
  },
  Course_Completed: {
    Course_Completed: (param: CourseSlideClick) => param,
    config,
  },
  Course_Slide_Viewed: {
    Course_Slide_Viewed: (param: CourseSlideViewed) => param,
    config,
  },
  Start_Course_Clicked: {
    Start_Course_Clicked: (param: CourseClicked) => param,
    config,
  },
  Resume_Course_Clicked: {
    Resume_Course_Clicked: (param: CourseClicked) => param,
    config,
  },
  All_Resources_Load_Tracked: analytics.trackCreator<AllResourcesLoadTracked>({
    ...config,
    eventName: 'All_Resources_Load_Tracked',
  }),
  Filter_Search_Clicked: {
    Filter_Search_Clicked: (param: SearchClicked) => param,
    config,
  },
  AllResources_SearchResult_Clicked: {
    AllResources_SearchResult_Clicked: (param: SearchResultClicked) => param,
    config,
  },
}
